export default {
  index: [
    {
      path: '/gzdetils',
      component: resolve => require(['./gzdetilsIndex.vue'], resolve),
    },
    {
      path: '/gzdetilstwo',
      component: resolve => require(['./gzdetilstwoIndex.vue'], resolve),
    },

    {
      path: '/gzdetilshz',
      component: resolve => require(['./gzdetilshzIndex.vue'], resolve),
    },
  ]
}



// WEBPACK FOOTER //
// ./src/view/gzdetils/_router.js